// Copyright 2025. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { Tooltip } from '@plesk/ui-library';
import { TwoLineText } from 'common/components/serverType/Styles';

export interface ICutTitleTwoLineProps {
    title: string;
    withTooltip?: boolean;
}

export const CutTitleTwoLine: React.FC<ICutTitleTwoLineProps> = ({
    title,
    withTooltip = true,
}) => {
    const textElement = <TwoLineText>{title}</TwoLineText>;
    return withTooltip ? <Tooltip title={title}>{textElement}</Tooltip> : textElement;
};

